import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { LayerPicker } from './components/LayerPicker';
import { Legend } from './components/Legend';
import { MapControls } from './components/MapControls';
import { Panel } from './components/Panel';
import { Toast } from './components/Toast';
import { MapView } from './map/MapView';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="app">
        <MapView />
        <div className="logo">
          <img src="/img/logo.png" alt="Project ENKI" />
        </div>
        <Legend />
        <MapControls />
        <Panel />
        <LayerPicker />
        <Toast />
      </div>
    </QueryClientProvider>
  );
}
